<template>
    <header class="flexbox">
        <div class="logo"><router-link to="/"><img src="../../assets/img/logo.png"></router-link></div>
        <div class="search">
            <div class="flexbox box">
                <el-input placeholder="" v-model="searchInput" @keyup.enter.native="searching"></el-input>
                <el-button @click="searching">搜索</el-button>
            </div>
            <div class="tips" v-show="hotsearch.length != 0">
                热门搜索：
                <router-link :to="{name: 'GoodsList', query: {type: 'querysearch', searchcontent: item.TSH_TITILE }}" v-for="item in hotsearch">{{ item.TSH_TITILE }}</router-link>
            </div>
        </div>
        <div class="cart">
            <el-popover
                placement="bottom"
                :width="400"
                trigger="hover"
                >
                <template #reference>
                    <router-link to="/shoppingcart">
                        <el-button>
                            <!-- <i class="el-icon-shopping-cart-full" style="color: #F42434;"></i> -->
                 <img src="../../assets/img/icon/cart.svg" >

                            我的购物车
                            <el-badge :value="shoCartLen" :max="99" class="item"></el-badge>
                        </el-button>
                    </router-link>
                </template>
                <div class="cartpop">
                    <div class="goodsbox">
                        <el-scrollbar max-height="400px">
                            <div class="flexbox cell" v-for="item in shopCart" :key="item.tsdId" @click="toProDetail(item.code)">
                                <img src="https://online.meide-casting.com/meide/la.img?fn">
                                <div class="msg">
                                    <div class="name">{{item.name}}</div>
                                    <div class="dec">规格：{{item.gg}}</div>
                                </div>
                                <div class="redw price">¥{{item.price}}</div>
                                <!-- <div class="del">x</div> -->
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="flexbox settlement">
                        <div class="allgoods">
                            <p>共{{ shoCartLen }}件商品</p>
                            <!-- <div class="redw">{{item.totalPrice}}元</div> -->
                        </div>
                        <div class="settle">
                            <router-link to="/shoppingcart">
                                <button>去购物车结算</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </el-popover>
        </div>
    </header>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onMounted, onBeforeMount, computed, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex'
    import { getUrlRelativePath } from'@/util/util.js'

    export default {
        name: 'Header',
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let store = useStore()
            let pageData = reactive({
                userInfo: {
                    customerCode: ''
                },
                hotsearch: [],
                searchInput: '',
                shopCart: [],
                shoCartLen: 0
            })
            // 重新查询购物车
            let shopCartRe = computed(() => {
                return store.state.headerShopCartRe
            })
            watch(shopCartRe, (nval, oval) => {
                if(nval == true) {
                    getShoppingCartPart('1')
                }
            })
            // watch(pageData.shopCart, (nval, oval) => {
            //     pageData.shopCart = nval
            // })
            // watch(pageData.shoCartLen, (nval, oval) => {
            //     pageData.shoCartLen = nval
            // })
            // 获取用户热搜词
            let getHotsearch = () => {
                let data = {
                    postType: 'queryhotsearch',
                    tshuser: pageData.userInfo.customerCode
                }
                proxy.$axios.postReq('/meide/REST/ajaxMdIndex', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.hotsearch = res.items
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 搜索
            let searchClick = ref(true)
            let searching = () => {
                if(pageData.searchInput == '') {
                    proxy.$alert('搜索框不能为空', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {}
                    })
                    return
                }
                if(searchClick.value) {
                    searchClick.value = false
                    router.push({
                        name: 'GoodsList',
                        query: {
                            type: 'querysearch',
                            searchcontent: pageData.searchInput
                        }
                    })
                    // pageData.searchInput = ''
                    // refreshpage()
                }
                setTimeout(() => {
                    searchClick.value = true
                }, 3000)

            }
            // 获取购物车内容
            let getShoppingCartPart = (ordertype) => {
                // console.log(ordertype,6666)
                let data = {
                    postType: 'easyQuery',
                    type: ordertype, // 订单类型（1:普通订单，2:项目订单，3:异地仓订单）
                }
                // console.log(data.type,9999)
                proxy.$axios.postNoLoadingReq('/meide/REST/ajaxShopCar', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.shopCart = [] // 先清空一下购物车数组
                        if(res.data.length > 0) {
                            if(res.data[0].proData) {
                                res.data[0].proData.map((item, index) => {
                                    if(index < 2) {
                                        pageData.shopCart.push(item)
                                    }
                                })
                            }
                        }
                        // 2021.12.9
                        pageData.shoCartLen = res.totalProductNum
                       //  console.log(res.totalProductNum)
                        store.commit('stopshopCartRe', false)
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 跳转商品详情
            let toProDetail = (code) => {
                router.push({
                    name: 'ProductDetails',
                    query: {}
                })
            }
            
            onBeforeMount(() => {
                if(localStorage.getItem('userInfo')) {
                    pageData.userInfo = JSON.parse(localStorage.getItem('userInfo'))
                    getShoppingCartPart('1')
                }
                if(router.currentRoute.value.query.searchcontent) {
                    pageData.searchInput = router.currentRoute.value.query.searchcontent
                }
            })
            onMounted(() => {
                getHotsearch()
            })
            return {
                ...toRefs(pageData),
                searchClick,
                searching,
                getHotsearch,
                getShoppingCartPart,
                toProDetail,
            }
        }
    }
</script>

<style scoped lang="scss">
    header {
        width: 1200px;
        margin: auto;
        justify-content: space-between;
        padding: 30px 0 15px 0;
        display: flex;
        align-items: flex-start;
    }
    .logo {
        img {
            width: 165px;
        }
    } 
    .search {
        .box {
            width: 560px;
            height: 40px;
            border-radius: 200px;
            border: 2px solid #F42434;
            ::v-deep(.el-input__inner) {
                border-radius: 200px;
                width: 440px;
                border: none;
                height: 36px;
            }
            ::v-deep(.el-button) {
                border-radius: 0 200px 200px 0;
                width: 130px;
                color: #fff;
                background: #F42434!important;
                border: none;
                height: 40px;
            }
        }
        .tips {
            margin-top: 10px;
            font-size: 12px;
            color: #666;
            padding: 0 15px;
            a {
                font-size: 12px;
                color: #666;
                margin-right: 6px;
            }
            a:hover {
                color: #F42434;
            }
        }
    }
    .cart {
        ::v-deep(.el-button) {
            width: 170px;
            border-radius: 200px;
            height: 40px;
            justify-content: space-around;
            box-shadow: 1px 1px 3px 1px #cdcdcd;
            border: none;
            i {
                margin-right: 5px;
            }
            .cartnum {
                padding: 2px 6px;
                background: #F42434!important;
                color: #fff;
                border-radius: 50%;
                font-size: 12px;
            }
        }
    }
</style>

<style lang="scss">
.cartpop {
    .goodsbox {
        .cell {
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 20px;
            img {
                width: 60px;
            }
            .msg {
                width: 200px;
                .name {
                    margin-bottom: 6px;
                }
                .dec {
                    font-size: 12px;
                    color: #999;
                }
            }
            .price {
                font-weight: bold;
            }
            .del {
                font-size: 16px;
                cursor: pointer;
            }
            .del:hover {
                font-weight: bold;
            }
        }
    }
    .settlement {
        justify-content: space-between;
        margin-top: 15px;
        .allgoods {
            p {
                font-size: 12px;
            }
            div {
                font-size: 18px;
                margin-top: 5px;
            }
        }
        .settle {
            button {
                border-radius: 5px;
                background: #F42434!important;
                color: #fff;
                height: 40px;
                width: 120px;
                cursor: pointer;
            }
        }
    }
}
::v-deep(.el-badge__content--primary){
background: red!important;
}
</style>